import { ManageByProgram } from './../models/imanage.model';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import {
  Component,
  OnInit,
  ViewChild,
  ViewContainerRef,
  OnDestroy,
  AfterViewInit
} from '@angular/core';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
// tslint:disable-next-line:import-blacklist
import { Subject } from 'rxjs';
import { Cms } from '../cms/models/cms.model';
import { IBreadcrumb } from '../breadcrumb/breadcrumb.interface';
import { NgProgressService } from '../services/ngProgress.service';
import { filter, map, takeUntil } from 'rxjs/operators';
import { PanelService } from '../services/panel.service';
import { CustomerService } from '../services/customer.service';
import { CommonService } from '../services';
import { MatTableDataSource } from '@angular/material/table';
import { DDCustomer } from '../models/customer.model';


@Component({
  selector: 'customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.css']
})
export class CustomersComponent implements OnInit, OnDestroy, AfterViewInit {

  title = 'Customers';

  public customers: DDCustomer[] = [];
  public dataSource: MatTableDataSource<DDCustomer>
  public displayedColumns: string[] = ['customerName', 'manage'];

  created = false;

  narrowMode = false;
  hideFirstLevel = false;
  loadContent = false;
  singleBlade = false;
  isStaffAccount: boolean = false;
  public showAddNewUserBtn = false;

  activePrograms: ManageByProgram[];
  dicoverPrograms: ManageByProgram[];

  // unsubscribe
  ngUnsubscribe: Subject<void> = new Subject<void>();

  @ViewChild('entry', { read: ViewContainerRef })
  entry: ViewContainerRef;
  @ViewChild(BreadcrumbComponent, {static: false}) breadcrumbRef: BreadcrumbComponent; // reference to the breadcrumb

  // css variable
  subWidth: string;

  // filter
  searchField = '';

  cms: Cms;
  viewChildId = null;
  public breadcrumbs: IBreadcrumb[] = [];
  cmsId: string = null;
  isBreadCrumbsUpdated = false;


  constructor(
    private activeRouter: ActivatedRoute,
    private customerService: CustomerService,
    private router: Router,
    public ngProgress: NgProgressService,
    private commonService: CommonService,
    public panelService: PanelService
  ) {
    commonService.emitUpdateSideBarActiveItem('customers');
  }

  ngOnInit() {
    if (this.router.url !== '/customers') {
      this.narrowMode = true;
    }

    this.router.events.pipe(takeUntil(this.ngUnsubscribe)).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url === '/customers') {
          this.narrowMode = false;

          $('.page-contents').animate({ scrollLeft: 0 }, 400);

        }
        // determine if it is manage details page or create new tenant page
        if (event.url.includes('Details')) {
          this.hideFirstLevel = true;

        } else {
          this.hideFirstLevel = false;
        }
      }
    });

    this.fetchCustomers();

    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => this.breadcrumbRef.ngAfterViewInit());

    this.customerService.refetchCustomerList$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => this.fetchCustomers());
  }

  private fetchCustomers() {
    this.customerService.getCustomers()
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(map((apiCustomers) => apiCustomers.map((c) => new DDCustomer(c))))
      .subscribe((res: DDCustomer[]) => {
        this.customers = [ ...res ];
        this.dataSource = new MatTableDataSource(this.customers);
        this.customerService.monitorCustomerList(this.customers);
        this.loadContent = true;
      });
  }

  ngAfterViewInit() {

  }

  ngOnDestroy(): void {
    this.commonService.emitUpdateSideBarActiveItem('');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  addCustomerEvent(): void {
    this.narrowMode = true;
    this.router.navigate(["customer-form"], {
      relativeTo: this.activeRouter,
    });
  }

  close() {
    this.router.navigateByUrl('/home');
  }

  navigateTo(url: string) {
    this.router.navigate([url]);
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  isActive(customerId?: string): boolean {
    const urlArray = this.router.url.split('/');
    return urlArray.indexOf(customerId) > -1;
  }

  public manageCustomerEvent(customer: DDCustomer): void {
    this.narrowMode = true;
    this.router.navigate([customer.id], {
      relativeTo: this.activeRouter,
    });
  }
}
